import React from 'react';
import { SkeletonStyleProps } from './SkeletonStyleProps';

/**
 * @internal
 */
export const SkeletonThemeContext = React.createContext<SkeletonStyleProps>({});
